import React, { Component } from "react";
import { Grid, Button } from "@material-ui/core";
import { ArrowBack, MonetizationOn, Redo } from "@material-ui/icons";
import { colors, metrics } from "../../styles";
import { constants } from "../../config";
import { navigate } from "../../actions/routerResolve";
import { connect } from "react-redux";
import ColorService from "../../tools/ColorsService";

class View extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
      profileUser: JSON.parse(localStorage.getItem(constants.userKey)).user
        .profile,
    };
  }

  handleColor = () => {
    switch (this.props.status) {
      case "EmAndamento":
        return colors.green500;
      case "Agendado":
        return colors.primary;
      case "Programado":
        return colors.primary;
      case "Confirmado":
        return colors.yellow500;
      case "Solicitado":
        return colors.regular;
      case "Cancelado":
        return colors.regular;
      case "Alterado":
        return colors.red500;
      default:
        return colors.regular;
    }
  };

  buttonHover = () => {
    this.setState({ hover: !this.state.hover });
  };

  handleTextColor = () => {
    switch (this.props.status) {
      case "EmAndamento":
        return colors.white;
      case "Agendado":
        return colors.white;
      case "Programado":
        return colors.white;
      case "Confirmado":
        return colors.white;
      case "Solicitado":
        return colors.white;
      case "Cancelado":
        return colors.white;
      case "Alterado":
        return colors.white;
      default:
        return colors.white;
    }
  };

  render() {
    var styleButton = {
      width: "20%",
      height: "100%",
      padding: 0,
      margin: 0,
      // color: ColorService.contrastColor(this.props.status),
      backgroundColor: "rgba(0,0,0,0.12)",
    };

    if (this.state.hover) {
      styleButton.backgroundColor = "rgba(0,0,0,0.3)";
    } else {
      styleButton.backgroundColor = "rgba(0,0,0,0.12)";
    }

    return (
      <Grid
        container
        style={{
          padding: metrics.paddingPage,
          color: ColorService.contrastColor(this.props.status),
          backgroundColor: ColorService.backgroundColor(this.props.status),
          paddingBottom: metrics.paddingPage + 20,
        }}
      >
        <Grid container>
          <Grid container>
            <Grid container justify="flex-start" item md={2} sm={2}>
              <Button
                onClick={() => this.props.navigate("/")}
                component="span"
                style={{
                  width: "20%",
                  height: "100%",
                  padding: 0,
                  margin: 0,
                  color: ColorService.contrastColor(this.props.status),
                }}
              >
                <ArrowBack />
              </Button>
            </Grid>
            {/* <Grid item md={3} style={styles.item}>
                                    <MonetizationOn style={{ fontSize: 30 }} /><br />
                                    {this.state.shutle.cost_center && <h4 style={{ margin: 5, marginLeft: 0 }} >{this.state.shutle.cost_center.name}</h4>}
                                </Grid> */}
            {this.state.profileUser !== "Passageiro" && (
              <Grid container justify="flex-end" item md={10} sm={10}>
                <Button
                  disabled={this.props.loadingEdit}
                  onClick={() =>
                    this.props.navigate("/new-mission/" + this.props.shutle.id)
                  }
                  component="span"
                  style={styleButton}
                  onMouseEnter={this.buttonHover}
                  onMouseLeave={this.buttonHover}
                >
                  Editar Missão
                </Button>
              </Grid>
            )}
          </Grid>
          <Grid container>
            <Grid
              container
              justify="center"
              style={{ alignItems: "center" }}
              item
              md={5}
              sm={5}
            >
              <MonetizationOn />
              {
                <h3 style={{ margin: 5 }}>
                  {this.props.shutle.cost_center
                    ? this.props.shutle.cost_center.name
                    : "Não definido"}
                </h3>
              }
            </Grid>
            <Grid
              container
              item
              md={2}
              justify="center"
              style={{ textAlign: "center" }}
            >
              {
                <h3 style={{ margin: 5 }}>
                  {this.props.shutle.flight_denomination
                    ? this.props.shutle.flight_denomination
                    : "Não definido"}
                </h3>
              }
            </Grid>
            <Grid
              container
              justify="center"
              style={{ alignItems: "center" }}
              item
              md={5}
              sm={5}
            >
              <Redo style={{ marginLeft: 5 }} />{" "}
              <h3>
                {this.props.shutle.flight_stages.length}
                {this.props.shutle.flight_stages.length > 1
                  ? " Etapas"
                  : " Etapa"}{" "}
              </h3>
            </Grid>
          </Grid>
          <Grid
            container
            justify="center"
            alignItems="center"
            item
            md={5}
            sm={4}
            style={{
              fontFamily: "Roboto",
              justifyItems: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <Grid item md={12}>
              <span>ORIGEM</span>
              {this.props.shutle.flight_stages[0] && (
                <h3 style={{ margin: 5 }}>
                  {this.props.shutle.flight_stages[0].from}
                </h3>
              )}
            </Grid>
          </Grid>
          <Grid
            container
            justify="center"
            alignItems="center"
            item
            md={2}
            sm={4}
            style={{ alignItems: "center", justifyItems: "center" }}
          >
            <Grid item md={12}>
              <img src={ColorService.image(this.props.status)} />
            </Grid>
            <Grid
              item
              md={12}
              sm={12}
              style={{
                fontFamily: "Roboto",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <br />
              <span style={{ fontSize: 12 }}>AERONAVE</span>
              {/* {this.props.shutle.aircraft_type && this.props.shutle.aircraft? this.props.shutle.aircraft_type.type || this.props.shutle.aircraft.aircraft_model.icao_model || this.props.shutle.aircraft.marks? <span>{this.props.shutle.aircraft_type.type.toUpperCase()}<br/>{this.props.shutle.aircraft.aircraft_model.icao_model}<br/>{this.props.aircraft.marks}</span>:false: '?'} */}
              {this.props.shutle.aircraft_type && (
                <h4 style={{ margin: 5 }}>
                  {this.props.shutle.aircraft_type.type}
                </h4>
              )}
              {this.props.shutle.aircraft && (
                <h4 style={{ margin: 5 }}>
                  {this.props.shutle.aircraft.aircraft_model.icao_model}
                </h4>
              )}
              {this.props.shutle.aircraft && (
                <h4 style={{ margin: 5 }}>
                  {this.props.shutle.aircraft.marks}
                </h4>
              )}
            </Grid>
            <br />
            <Grid
              item
              md={12}
              sm={12}
              style={{
                fontFamily: "Roboto",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <span style={{ fontSize: 12 }}>SOLICITANTE</span>
              {this.props.shutle.created_by && (
                <h4 style={{ margin: 5 }}>
                  <span>
                    {this.props.shutle.created_by.first_name || ""}{" "}
                    {this.props.shutle.created_by.last_name || ""}
                  </span>
                </h4>
              )}
            </Grid>
          </Grid>
          <Grid
            container
            item
            md={5}
            sm={4}
            style={{
              fontFamily: "Roboto",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <Grid item md={12}>
              <span>DESTINO</span>
              {this.props.shutle.flight_stages[0] && (
                <h3 style={{ margin: 5 }}>
                  {this.props.shutle.flight_stages[0].to}
                </h3>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  navigate,
};

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./src/routes/flight/View.js